/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */

export const MenuItems4 = [
    {
        label: 'Usuarios Autogestión', index: 0,
        url: '/Users',
    },
    {
        label: 'Gestión de contraseña', index: 1,
        url: '/Password_management',
    }
]